<h2>Cadastro de motoristas</h2>

<div class="tds-row tds-u-gap3">
  <app-button
    text="Cadastro Parcial"
    (clicked)="partial_registration()"
  ></app-button>
  <app-button
    text="Cadastro Completo"
    (clicked)="full_registration()"
  ></app-button>
</div>
